import { useContext, useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { motion } from 'framer-motion';
import SingleInput from '../../../components/SingleInput';
import { AppContext } from '../../../hooks/auth/useAppContext';
import { useForm } from 'react-hook-form';
import { useStandardCall } from '../../../hooks/useStandardCall';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
export function SuggestionsTab({setActiveTab,role}) {
  const navigate = useNavigate();
  let lng = window.location.pathname.split('/')[1] ?? 'it';
  const [currentLng, setCurrentLng] = useState(lng);
  const appContext = useContext(AppContext);
  const [statusForm, setStatusForm] = useState(null);
  const [resource, setResourse] = useState(TheApp.Res);
  const {
    register,
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { errors }
  } = useForm();
  const stdCall = useStandardCall();
  function onSendMessage(data) {

    // date
    const rq = {
      Content: data.Content,
      Type: data.Type.value,
    };

    appContext._setters._setLoading(true);
    stdCall.post('app/ht/report', rq, (rs) => {
      if (rs.Success) {
        setStatusForm({
          status: true,
          success: true,
          message: 'Messaggio inviato correttamente'
        });
        reset();
      } else {
        setStatusForm({
          status: true,
          success: false,
          message: rs.Message
        });
      }
    }).catch(error => {
      setStatusForm({
        status: true,
        message: resource["Form.GenericError"] ?? `Si è verificato un errore, riprova più tardi.`,
        success: false
      });
    })
      .finally(() => {
        appContext._setters._setLoading(false);
      });
  }


  useEffect(() => {
    if (statusForm) {
      if (statusForm?.success) {
        const toasts = toast.success(statusForm?.message);
      }
      if (!statusForm?.success) {
        const toasts = toast.error(statusForm?.message);
      }
    }
  }, [statusForm]);

  const inputs = [
    {
      id: 'Type',
      label: resource["Form.Subject"] ??  'Oggetto',
      type: 'select',
      isMulti: false,
      placeholder: resource["Form.SelectSuggestionType"] ?? `Seleziona la tipologia`,
      layout: 'col-lg-12 col-md-6',
      validationSchema: {
        required: 'Campo obbligatorio'
      },
      options:
      {
        Items: [
          { Value: 0, Label: resource["Form.Suggestions.Suggestion"] ??  'Suggerimento' },
          { Value: 1, Label: resource["Form.Suggestions.Report"] ??   'Segnalazione' },
        ]
      }
    },
    {
      id: 'Content',
      label: resource["Form.Suggestions.Message"] ?? 'Messaggio',
      type: 'textarea',
      placeholder: resource["Form.Suggestions.Message.Placeholder"] ??  'Insersci il messaggio da inviare',
      icon: 'fa fa-map-marker',
      layout: 'col-lg-12 col-md-12'
    }
  ];


  useEffect(() => {
    setResourse(TheApp.Res[TheApp.Locale]);
  }, [resource]);

  return (
    <div className="wrapper-sender-message">
    <div className="wrapper-sender-message__header">
      <div className="wrapper-sender-message__header__title">
        <h3>{resource["Suggestions.Title"] ??  "Inviaci un suggerimento o una segnalazione"}</h3>
      </div>
      <div
          className="btn-close"
          onClick={(e) => {
            e.preventDefault();
            if(role == "CLUB") setActiveTab("alievi")
            else setActiveTab("test");
            navigate(`/${currentLng}/dashboard`);
          }}>
          <i className="fa-solid fa-circle-xmark"></i>
        </div>
    </div>
    <div className="wrapper-form">
      <form onSubmit={handleSubmit(onSendMessage)}>
        <div className="row">
          {inputs.map((input) => (
            <SingleInput
              key={input.id}
              errors={errors}
              register={register}
              control={control}
              setValue={setValue}
              {...input}
            />
          ))}
        </div>
        <input
          value={resource["Form.Send"] ??  'invia messaggio'}
          type="submit"
          className="btn primary"
        />
      </form>
      <div
        className={`wrapper-message to-appear ${
          statusForm?.status
            ? statusForm?.success
              ? 'alert-success'
              : 'alert-danger'
            : ''
        } ${statusForm?.status ? 'visible' : ''}`}>
        {statusForm?.status && <p>{statusForm?.message}</p>}
      </div>
    </div>
  </div>
  );
}
